import React from "react";
import { Grid } from "@mui/material";
import TopNavBar from "../../Components/TopBar/Navbar";

const PrivacyPolicy = () => {
  return (
    <Grid
      container
      sm={12}
      xs={12}
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"flex-start"}
      className="leaderboard_page"
    >
      <Grid container position={"fixed"} zIndex={100}>
        <TopNavBar />
      </Grid>
      <Grid lg={6} style={{ marginTop: "7%",alignItems:"center",alignContent:"center" }}>
        `
        <Grid className=" p-2" lg={12} marginTop={{lg:"0%",md:"0%",sm:"7%",xs:"7%"}} >
          {" "}
          <h1 style={{ textAlign: "center" }}>Privacy Policy</h1>{" "} 
        </Grid>
        <Grid className=" p-2"   >
          <p  >
            This website and any directly or indirectly related or connected
            third-party service provider may use cookies for personalisation,
            statistical and quality of service purposes and can collect user
            access and usage data for legitimate development and statistical
            purposes. You may manage your cookie preferences here below. Please
            note, however, that even if you reject any and all cookies, which
            might result in a suboptimal user experience or in the OpenZK
            platform not fully working as intended, you still inherently consent
            to the collection of other usage data by simply interacting with any
            element of this website or any herein accessible digital software
            and/or platform through technologies other than cookies, including
            when such collection might qualify as an interception of
            communications by third parties.{" "}
          </p>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PrivacyPolicy;
